import React, { useState } from 'react';

const Header = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <div id="top" className="scroll-mt-28 grid grid-cols-1 items-end gap-10 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-14">
      <div className="hero-in shrink-0">
        <div className="h-56 w-44 overflow-hidden bg-spruce-soft sm:h-72 sm:w-56">
          {!imageError ? (
            <img
              src="/Headshot.png"
              alt="Zachary Klein"
              className="h-full w-full object-cover object-[center_15%]"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center font-display text-4xl font-extrabold text-spruce">
              ZK
            </div>
          )}
        </div>
      </div>

      <div className="hero-in-delay min-w-0">
        <h1 className="font-display text-5xl font-extrabold leading-[0.95] tracking-tight text-ink sm:text-6xl">
          Zachary
          <br />
          Klein
        </h1>
        <p className="mt-5 text-lg text-muted">
          Computer Science and Economics · AI Development minor · Tufts 2028
        </p>
        <p className="mt-6 max-w-md text-[1.05rem] leading-relaxed text-ink/90">
          I love to learn through building new projects. Most recently I built AI agents and MCP integrations
          at Lead Bank. I care about making internal tools and research
          infrastructure actually usable.
        </p>
        <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-muted">
          <a href="mailto:zachkklein@gmail.com" className="link-accent hover:text-ink">
            zachkklein@gmail.com
          </a>
          <a href="https://linkedin.com/in/zachkklein" target="_blank" rel="noopener noreferrer" className="link-accent hover:text-ink">
            LinkedIn
          </a>
          <a href="https://github.com/zachkklein" target="_blank" rel="noopener noreferrer" className="link-accent hover:text-ink">
            GitHub
          </a>
          <a href="/Zachary_Klein_Resume.pdf" target="_blank" rel="noopener noreferrer" className="link-accent hover:text-ink">
            Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
